import { render, staticRenderFns } from "./TaskAssignedNotification.vue?vue&type=template&id=2ab8b8c3&scoped=true&"
import script from "./TaskAssignedNotification.vue?vue&type=script&lang=js&"
export * from "./TaskAssignedNotification.vue?vue&type=script&lang=js&"
import style0 from "./TaskAssignedNotification.vue?vue&type=style&index=0&id=2ab8b8c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab8b8c3",
  null
  
)

export default component.exports